import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as AlertIcon } from '../../../assets/icons/alert-color-icon-ne.svg';
import { ReactComponent as ErrorIcon } from '../../../assets/icons/error-color-icon-ne.svg';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info-color-icon-ne.svg';
import { ReactComponent as SuccessIcon } from '../../../assets/icons/success-color-icon-ne.svg';
import { CARD_STATUS } from '../../constants/constants';
import { ICardStatusProps } from '../../interfaces/global';
import StyledButtonNE from '../StyledButtonNE/StyledButtonNE';
import './CardStatusNE.scss';

const CardStatusNE = ({ message, type, button, buttonText, className = '' }: ICardStatusProps) => {
  const { t } = useTranslation();

  const loadImage = () => {
    if (type === CARD_STATUS.success) {
      return <SuccessIcon data-testid="success-icon" />;
    }
    if (type === CARD_STATUS.error) {
      return <ErrorIcon data-testid="error-icon" />;
    }
    if (type === CARD_STATUS.informative) {
      return <InfoIcon data-testid="info-icon" />;
    }
    if (type === CARD_STATUS.alert) {
      return <AlertIcon data-testid="alert-icon" />;
    }
  };

  return (
    <div className={`w-full flex status-card-container-ne ${type} p-4 ${className}`} data-experience="new">
      <div className=" h-6 w-6">{loadImage()}</div>
      <div className="status-card-text-ne self-center pl-2 text-left"> {message} </div>
      {button !== undefined && buttonText !== undefined && (
        <div className="self-center ml-auto">
          <StyledButtonNE {...button}>{t(buttonText)}</StyledButtonNE>{' '}
        </div>
      )}
    </div>
  );
};

export default CardStatusNE;
